import { TuiTabs } from '@taiga-ui/kit';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  OnDestroy,
  OutputEmitterRef,
  OutputRefSubscription,
  signal,
} from '@angular/core';
import {
  RequestFilesPersonType,
  RequestFormFilesRoutePaths,
} from '@features/requests/request-form/components/request-form-files/types';
import {
  RequestFormFilesCommonComponent,
  RequestFormFilesDownloadComponent,
} from '@features/requests';
import { RequestFile, RequestFileCategory } from '@core/types';
import { Nullable } from '@core/helpers';

@Component({
  selector: 'x-files-block',
  imports: [
    TuiTabs,
    RequestFormFilesCommonComponent,
    RequestFormFilesDownloadComponent,
  ],
  templateUrl: './files-block.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilesBlockComponent implements OnDestroy {
  $files = input.required<Nullable<RequestFile[]>>({
    alias: 'files',
  });

  $fileCats = input.required<Nullable<RequestFileCategory[]>>({
    alias: 'fileCats',
  });
  $fileTabChange = input<OutputEmitterRef<RequestFormFilesRoutePaths>>(
    undefined,
    {
      alias: 'fileTabChange',
    },
  );

  $showFileModal = input<OutputEmitterRef<void>>(undefined, {
    alias: 'showFileModal',
  });

  viewScreen = signal<RequestFormFilesRoutePaths>(
    RequestFormFilesRoutePaths.Installer,
  );

  ViewScreenType = RequestFormFilesRoutePaths;

  RequestFilesPerson = RequestFilesPersonType;

  private fileTabChangeEmitterSub: Nullable<OutputRefSubscription> = null;

  constructor() {
    effect(() => {
      const fileTabChangeEmitter = this.$fileTabChange();

      if (fileTabChangeEmitter) {
        this.fileTabChangeEmitterSub = fileTabChangeEmitter.subscribe(tab => {
          this.viewScreen.set(tab);
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.fileTabChangeEmitterSub) {
      this.fileTabChangeEmitterSub.unsubscribe();
      this.fileTabChangeEmitterSub = null;
    }
  }
}
